// extracted by mini-css-extract-plugin
module.exports = {"HomePageLanding":"styles_HomePageLanding__3LrnM","HomePageLanding_Heading":"styles_HomePageLanding_Heading__3rY-T"};